export default __webpack_public_path__ + "static/media/profile.9330ef04.svg";